(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mg-size-chart')) {
    // Column labels we can match a variant value like "Eur 37/ Uk 4/ 23cm" against
    const SIZE_SYSTEMS = [
      ['eu', /\b(eu|eur|euro)\b/],
      ['uk', /\b(uk|pak)\b/],
      ['us', /\bus\b/],
      ['cm', /(\bcm\b|\d\s*cm\b|\bjp\b|\bmondo)/],
    ];

    const systemOf = (text) => SIZE_SYSTEMS.find(([, pattern]) => pattern.test(text))?.[0] || '';

    const numberOf = (text) => {
      const match = String(text).match(/\d+(?:\.\d+)?/);
      return match ? parseFloat(match[0]) : null;
    };

    /** "XXL" and "2XL" (or "X-Large") should be treated as the same size. */
    const normalizeSize = (text) => {
      let value = String(text).toLowerCase().replace(/["'\s-]/g, '').replace('extra', 'x').replace('large', 'l').replace('small', 's').replace('medium', 'm');
      const repeated = value.match(/^(x{2,})(s|l)$/);
      if (repeated) value = `${repeated[1].length}x${repeated[2]}`;
      return value;
    };

    /**
     * Size chart popup for the product variant picker.
     * Highlights the row for the selected size (also unit-aware: Eur / UK / cm columns),
     * switches to the table that matches when the product type isn't known, and keeps
     * the tabs keyboard accessible.
     */
    class MgSizeChart extends HTMLElement {
      #abort = null;
      #observer = null;
      #tables = [];

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        // Drop screen-reader notes left from a previous render before reading the cells
        for (const note of this.querySelectorAll('tbody .mg-vsc__sr')) note.remove();
        this.tabs = [...this.querySelectorAll('[data-mg-tab]')];
        this.#tables = [...this.querySelectorAll('[data-mg-pane]')].map((pane) => ({
          pane,
          id: pane.dataset.mgPane,
          systems: [...pane.querySelectorAll('thead th')].map((th) => systemOf(th.textContent.toLowerCase())),
          rows: [...pane.querySelectorAll('tbody tr')].map((tr) => ({
            tr,
            cells: [...tr.cells].map((cell) => cell.textContent.trim().toLowerCase()),
          })),
        }));

        for (const tab of this.tabs) {
          tab.addEventListener('click', () => this.#select(tab, false), { signal });
          tab.addEventListener('keydown', (event) => this.#onTabKey(event), { signal });
        }

        // Re-check the highlight every time the popup opens (the shopper may have changed size)
        const dialog = this.closest('dialog');
        if (dialog) {
          this.#observer = new MutationObserver(() => {
            if (dialog.open) this.sync(true);
          });
          this.#observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
        }

        this.sync(false);
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#observer?.disconnect();
      }

      /** Highlight the selected size in every table; optionally scroll it into view. */
      sync(reveal) {
        const raw = this.#selectedValue();
        const value = raw ? this.#parse(raw) : null;
        const results = [];

        for (const table of this.#tables) {
          let best = null;
          let bestScore = 0;
          for (const row of table.rows) {
            this.#mark(row.tr, false);
            if (!value) continue;
            const score = this.#score(row, table.systems, value);
            if (score > bestScore) {
              best = row.tr;
              bestScore = score;
            }
          }
          if (best) this.#mark(best, true);
          results.push({ table, best, score: bestScore });
        }

        // Product type unknown: open the table that actually contains the selected size
        if (this.hasAttribute('data-auto-tab') && this.tabs.length) {
          const current = results.find(({ table }) => !table.pane.hidden);
          const winner = results.reduce((a, b) => (b.score > a.score ? b : a), results[0]);
          if (winner && current && winner.score > current.score) {
            const tab = this.tabs.find((t) => t.dataset.mgTab === winner.table.id);
            if (tab) this.#select(tab, false);
          }
        }

        if (!reveal) return;
        const visible = results.find(({ table }) => !table.pane.hidden);
        visible?.best?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }

      #picker() {
        return this.closest('.hdt-product__variant-picker')?.querySelector('hdt-variant-picker') || document.getElementById(this.dataset.picker);
      }

      #selectedValue() {
        const index = this.dataset.sizeIndex;
        if (index === undefined || index === '-1') return '';
        const fieldset = this.#picker()?.querySelector(`fieldset[data-index="${index}"]`);
        if (!fieldset) return '';
        const value = (
          fieldset.querySelector('input[type="radio"]:checked')?.value ||
          fieldset.querySelector('input[is-value]')?.value ||
          fieldset.querySelector('[update-value]')?.textContent ||
          ''
        ).trim();
        return value && value !== this.dataset.placeholder ? value : '';
      }

      #parse(raw) {
        const lower = raw.toLowerCase();
        const parts = lower.split(/[\/,|;]+/).map((part) => part.trim()).filter(Boolean);
        return {
          whole: normalizeSize(lower),
          parts: parts.map(normalizeSize),
          numbers: parts.map((part) => ({ system: systemOf(part), n: numberOf(part) })).filter((part) => part.n !== null),
        };
      }

      #score(row, systems, value) {
        let score = 0;
        const first = normalizeSize(row.cells[0] || '');
        if (first && (first === value.whole || value.parts.includes(first))) score += 100;

        for (const { system, n } of value.numbers) {
          if (system) {
            // "Uk 4" must sit in the UK column, "23cm" in the CM column, etc.
            const column = systems.indexOf(system);
            if (column !== -1 && numberOf(row.cells[column] || '') === n) score += 30;
          } else if (row.cells.some((cell) => /^\d+(\.\d+)?$/.test(cell) && parseFloat(cell) === n)) {
            score += 5;
          }
        }
        return score;
      }

      #mark(tr, active) {
        tr.classList.toggle('is-active', active);
        tr.querySelector('.mg-vsc__sr')?.remove();
        if (!active) return;
        const note = document.createElement('span');
        note.className = 'mg-vsc__sr';
        note.textContent = ` (${this.dataset.selectedLabel || 'Your selected size'})`;
        tr.cells[0]?.append(note);
      }

      #select(tab, focus) {
        for (const t of this.tabs) {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
          const pane = this.querySelector(`#${CSS.escape(t.getAttribute('aria-controls'))}`);
          if (pane) pane.hidden = !active;
        }
        if (focus) tab.focus();
      }

      #onTabKey(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next = null;
        if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        this.#select(this.tabs[(next + this.tabs.length) % this.tabs.length], true);
      }
    }

    customElements.define('mg-size-chart', MgSizeChart);
  }
  } catch(e) { console.error(e); }
})();

})();
